export default __webpack_public_path__ + "static/media/casian-lacatusu.8bd2b5ab.png";